import React from 'react'
import PropTypes from 'prop-types'
import Modal from './Modal'

const LayerDescription = ({ description, title }) => {
    return (
        <Modal>
            <header>
                <h2 className="title">{title}</h2>
            </header>
            <div>{description}</div>
        </Modal>
    )
}

LayerDescription.propTypes = {
    description: PropTypes.oneOfType([PropTypes.string, PropTypes.node, PropTypes.arrayOf(PropTypes.node)]).isRequired,
    title: PropTypes.string.isRequired
}

export default LayerDescription
